var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ex-latest-tx-wrapper" },
    [
      _c("div", { staticClass: "__center-title" }, [
        _vm._v(_vm._s(_vm.$t("trade.latestTx.title")))
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "__center-tb-title" }, [
        _c("span", { staticClass: "__center-tb-item" }, [
          _vm._v(
            "\n            " +
              _vm._s(
                _vm.$t("trade.priceTitle", {
                  price: _vm.quoteTokenDetail
                    ? _vm.quoteTokenDetail.originalSymbol
                    : ""
                })
              ) +
              "\n        "
          )
        ]),
        _vm._v(" "),
        _c("span", { staticClass: "__center-tb-item left __ellipsis" }, [
          _vm._v(
            "\n            " +
              _vm._s(
                _vm.$t("trade.amountTitle", {
                  amount: _vm.tradeTokenDetail
                    ? _vm.tradeTokenDetail.originalSymbol
                    : ""
                })
              ) +
              "\n        "
          )
        ]),
        _vm._v(" "),
        _c("span", { staticClass: "__center-tb-item tx-time" }, [
          _vm._v(_vm._s(_vm.$t("trade.latestTx.time")))
        ])
      ]),
      _vm._v(" "),
      _c("loading", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.isLoading,
            expression: "isLoading"
          }
        ],
        staticClass: "ex-center-loading",
        attrs: { loadingType: "dot" }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "tx-list-wrapper" },
        _vm._l(_vm.latestTxList, function(tx, i) {
          return _c(
            "div",
            {
              key: i,
              staticClass: "__center-tb-row __pointer",
              on: {
                click: function($event) {
                  return _vm.clickRow(tx)
                }
              }
            },
            [
              _c(
                "span",
                {
                  staticClass: "__center-tb-item",
                  class: {
                    buy: tx.side === 0,
                    sell: tx.side === 1
                  }
                },
                [_vm._v(_vm._s(_vm.formatNum(tx.price, "price")))]
              ),
              _vm._v(" "),
              _c("span", { staticClass: "__center-tb-item left" }, [
                _vm._v(_vm._s(_vm.formatNum(tx.quantity, "quantity")))
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "__center-tb-item tx-time" }, [
                _vm._v(_vm._s(_vm.getDate(tx.time * 1000)))
              ])
            ]
          )
        }),
        0
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }